import { DevicePluginFacade } from './DevicePluginFacade';
import { internalLogger } from '../../../interface/v1/clientOsLogger';
import { ApplicationContextEnum } from '../../applicationService/enums';
import { getServices } from '../../../infra/startup';

export let deviceVersion: string;
/**
 * Checks if the version string matches HP Smart app versions 158-163
 */
export const isHpSmartAppVersion = (versionString: string): boolean => {
  // Regex to match version starting with 158-163
  const versionPattern = /^(15[8-9]|16[0-3])\.[\d]+\.[\d]+/;
  return versionPattern.test(versionString);
};

/**
 * Gets the device version from JWeb DevicePlugin.
 * Returns empty string if not in NATIVE_PORTAL context or if an error occurs.
 */
export const getDeviceVersion = async (): Promise<string> => {
  if (deviceVersion !== undefined) return deviceVersion;

  const { applicationService } = getServices();
  const applicationContext = applicationService.getApplicationContext();

  if (applicationContext !== ApplicationContextEnum.NATIVE_PORTAL) return '';

  try {
    const devInfo = await DevicePluginFacade.getDeviceInfoCached();
    if (!devInfo.appVersion) {
      /* istanbul ignore next */
      internalLogger.error.e3({
        className: 'FacadeUtils',
        methodName: 'getDeviceVersion',
        message: 'JWeb Device app version was not found!',
        error: new Error('JWeb Device app version was not found!')
      });
    }
    deviceVersion = devInfo.appVersion || '';

    return deviceVersion;
  } catch (error) {
    /* istanbul ignore next */
    internalLogger.error.e3({
      className: 'FacadeUtils',
      methodName: 'getDeviceVersion',
      message: 'Error getting device info from JWeb',
      error: error
    });
    deviceVersion = '';
    return deviceVersion;
  }
};

export const cleanDeviceVersion = () => {
  deviceVersion = undefined;
};
